import { render, staticRenderFns } from "./BusinessMemberPlan.vue?vue&type=template&id=72f62202"
import script from "./BusinessMemberPlan.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports